import { type ObjectValuesUnionType } from '../utils/typing';

export const VideoPlayerTypes = Object.freeze({
  STREAM: 'stream',
  HIGHLIGHT: 'highlight',
});

export type VideoPlayerType = ObjectValuesUnionType<typeof VideoPlayerTypes>;
